var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckSave(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.1725 19.1625L8.7025 15.6925C8.51567 15.5052 8.26202 15.4 7.9975 15.4C7.73298 15.4 7.47933 15.5052 7.2925 15.6925C6.9025 16.0825 6.9025 16.7125 7.2925 17.1025L11.4725 21.2825C11.8625 21.6725 12.4925 21.6725 12.8825 21.2825L23.4625 10.7025C23.8525 10.3125 23.8525 9.68249 23.4625 9.29249C23.2757 9.10523 23.022 9 22.7575 9C22.493 9 22.2393 9.10523 22.0525 9.29249L12.1725 19.1625Z",
    fill: "#29CC39",
    stroke: "#29CC39",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckSave);
export default __webpack_public_path__ + "static/media/check_save.c8ac1caaf3ea16cab2ac616a29e27ed6.svg";
export { ForwardRef as ReactComponent };